import { formatValueUnit } from "./utils";

// roundDto: si es false, los descuentos resultantes se devuelven con
// decimales (p. ej. en ventas, donde el dto se guarda como float y solo se
// muestra redondeado en la tabla).
// roundTotal: si es false, los totales de línea se devuelven sin redondear a
// céntimos (p. ej. en la ficha de gafas, donde los precios se guardan como
// float y solo se muestran redondeados en los inputs).
export const calculateDtos = (
  lines,
  newTotal,
  roundDto = true,
  roundTotal = true,
) => {
  const formatDto = (dto) => (roundDto ? Math.round(dto) : dto);
  const formatTotal = (total) =>
    roundTotal ? Math.round(total * 100) / 100 : total;

  const getErrorMessage = (items, newTotal) => {
    let errorMessage = "";
    if (lines.length === 1) {
      errorMessage =
        "No es posible ajustar el precio a " +
        formatValueUnit(newTotal, "€") +
        " porque el producto sobrepasa el descuento máximo.";
    } else {
      let ids = "";
      items.forEach((item, i) => {
        ids += i < items.length - 1 ? item.id + " · " : item.id;
      });
      errorMessage =
        "No es posible ajustar el precio a " +
        formatValueUnit(newTotal, "€") +
        " porque los siguientes productos sobrepasan el descuento máximo:\n" +
        ids;
    }
    return errorMessage;
  };

  let linesN = structuredClone(lines);

  linesN = linesN.map((line, index) => {
    return {
      id_: index,
      id: line.id,
      total: line.total,
      dto: line.dto,
      dtoMax: line.dtoMax,
      pvp: line.pvp,
    };
  });

  const result = {
    lines,
    error: "",
  };

  let errorLines = linesN.filter((line) => {
    return line.dtoMax !== "" && line.dto > line.dtoMax;
  });

  if (errorLines.length > 0) {
    result.error = getErrorMessage(errorLines, newTotal);
  } else {
    const t = linesN.reduce((acc, curr) => {
      acc += curr.total;
      return acc;
    }, 0);

    // Techo real: el PVP sin descuento de cada línea (no el total actual,
    // que ya lleva el descuento aplicado), para permitir subir el total
    // hasta el precio original al reducir el descuento.
    const pvpTotal = linesN.reduce((acc, curr) => {
      const pvp = curr.dto < 100 ? curr.total / (1 - curr.dto / 100) : curr.total;
      return acc + pvp;
    }, 0);

    if (newTotal > pvpTotal) {
      result.error =
        "No es posible aplicar un importe superior al precio original.";
    } else {
      const d = newTotal / t;

      linesN.forEach((item) => {
        item.newTotal = item.total > 0 ? item.total * d : item.total;
        item.newDto =
          item.total > 0
            ? (1 - (item.newTotal / item.total) * (1 - item.dto / 100)) * 100
            : item.dto;
      });

      result.lines = linesN.map((line) => {
        return {
          id_: line.id_,
          id: line.id,
          total: formatTotal(line.newTotal),
          dto: formatDto(line.newDto),
          pvp: Math.round(line.pvp * 100) / 100,
          dtoMax: line.dtoMax,
        };
      });

      // El redondeo por línea puede dejar un descuadre de algún céntimo
      // respecto al total pedido: se imputa a la línea de mayor importe
      // para que la suma coincida exactamente con newTotal. Sin redondeo de
      // totales la suma ya coincide, así que no hace falta ajustar.
      const targetCents = Math.round(parseFloat(newTotal) * 100);
      const sumCents = result.lines.reduce(
        (acc, line) => acc + Math.round(line.total * 100),
        0,
      );
      const diffCents = targetCents - sumCents;
      if (roundTotal && diffCents !== 0) {
        const biggest = result.lines.reduce(
          (max, line) => (max === null || line.total > max.total ? line : max),
          null,
        );
        if (biggest && biggest.total > 0) {
          const original = linesN[biggest.id_];
          biggest.total =
            (Math.round(biggest.total * 100) + diffCents) / 100;
          biggest.dto = formatDto(
            (1 - (biggest.total / original.total) * (1 - original.dto / 100)) *
              100,
          );
        }
      }

      errorLines = result.lines.filter((line) => {
        return line.dtoMax !== "" && line.dto > line.dtoMax;
      });

      if (errorLines.length > 0) {
        result.error = getErrorMessage(errorLines, newTotal);
      } else {
        const res = [];
        lines.forEach((line, index) => {
          let r = result.lines.find((item) => {
            return item.id_ === index;
          });
          if (!r) {
            r = {
              id_: line.id_,
              id: line.id,
              total: line.total,
              dto: line.dto,
              pvp: line.pvp,
            };
          }
          res.push(r);
        });
        result.lines = res;
      }
    }
  }

  return result;
};
